import styles from "./MountSide3sets_Reusable.module.css";
import React, { useImperativeHandle, useRef, useState } from "react";
import play_icon from "../../../assets/images/icons/play_icon.png";

import html2canvas from "html2canvas-support-css";
import gallery_icon from "../../../assets/images/icons/gallery_ace.svg";

import domtoimage from "dom-to-image";
import { useNavigate } from "react-router-dom";
import EditScreenSelector from "../../Reusables/EditScreenSelector";
import AddressInfoDiv from "./AddressInfoDiv";

const MountSide3setsReusable = React.forwardRef(
  (
    {
      index,
      callback,
      callbackPreviewChange,
      state,
      image_selection_popup,
      //new stuff
      saveThisProduct,
      changeCopyDetails,
      selectedCopyDetails,
      currentPageNumber,
      totalPageNumber,
      confirmEdits,
      generatePreviewsAtBottom,
      preview_copied_image,
      item,
    },
    ref
  ) => {
    const { imageRight, imageLeft, imageMiddle01, imageMiddle02, midDouble } =
      state;
    const previewRef = useRef(null);
    const changeState = (key, value) => {
      state[key] = value;
      callback(state);
    };

    const changeStateMultiple = (keys, values) => {
      for (let i = 0; i < keys.length; i++) {
        state[keys[i]] = values[i];
      }
      callback(state);
    };

    const changePreview = async (id) => {
      let elementId = id.toString();
      try {
        const blob = await domtoimage.toBlob(
          document.getElementById(elementId),
          {
            bgcolor: "white",
          }
        );
        const file = new File([blob], "image.png", { type: "image/png" });

        // // Create a new image element with the generated file
        // const imgElement = new Image();
        // const objectURL = URL.createObjectURL(file);
        // imgElement.src = objectURL;

        // // Append the image to the body
        // document.body.appendChild(imgElement);

        return file;
      } catch (e) {
        console.log(e);
        return false;
      }
    };

    useImperativeHandle(ref, () => ({
      changePreview,
    }));

    const uploadImage = (num, id) => {
      if (
        imageRight !== "" &&
        imageLeft !== "" &&
        imageMiddle01 !== "" &&
        imageMiddle02 !== ""
      )
        return;
      if (num === 4) {
        image_selection_popup(index, imagesNeeded(), 0);
      } else {
        if (id === 1) {
          image_selection_popup(index, 1, 1);
        } else if (id === 2) {
          image_selection_popup(index, 1, 2);
        } else if (id === 3) {
          image_selection_popup(index, 1, 3);
        } else {
          image_selection_popup(index, 1, 4);
        }
      }
    };
    const [previewImage, setPreviewImage] = useState("");
    const divRef = useRef(null);
    const imagesNeeded = () => {
      let c = 0;
      if (imageLeft === "") {
        c++;
      }
      if (imageRight === "") {
        c++;
      }
      if (midDouble && imageMiddle02 === "") {
        c++;
      }
      if (imageMiddle01 === "") {
        c++;
      }
      return c;
    };
    const copyImageToPreview = () => {
      html2canvas(divRef.current, {
        logging: true,
        letterRendering: 1,
        allowTaint: false,
        useCORS: true,
        taintTest: false,
      }).then((canvas) => {
        // create an image from the canvas
        setPreviewImage(canvas.toDataURL());
      });
    };

    const [imageMidStyle, setImageMidStyle] = useState({
      width: "200px",
      height: "300px",
      objectFit: "cover",
    });

    const [imageLeftStyle, setImageLeftStyle] = useState({
      width: "200px",
      height: "300px",
      objectFit: "cover",
    });
    const [imageRightStyle, setImageRightStyle] = useState({
      width: "200px",
      height: "300px",
      objectFit: "cover",
    });
    const [preview, setPreview] = useState(false);
    const checkSmallerAspectRatio = (event, setMethod) => {
      const image = event.target;
      if (image.naturalWidth > image.naturalHeight) {
        setMethod({ width: "198px", height: "132px", objectFit: "cover" });
      } else {
        setMethod({ width: "132px", height: "198px", objectFit: "cover" });
      }
    };
    const checkAspectRatio = (event, setMethod) => {
      const image = event.target;
      if (image.naturalWidth > image.naturalHeight) {
        setMethod({ width: "300px", height: "200px", objectFit: "cover" });
      } else {
        setMethod({ width: "200px", height: "300px", objectFit: "cover" });
      }
    };

    //new 1
    const copyOptions = [];
    for (let i = 1; i < currentPageNumber; i++) {
      copyOptions.push(i + "個目と同じ");
    }
    copyOptions.push("別のデザインで作る");
    let copySelected = selectedCopyDetails + "個目の写真";
    const extractNumber = (s, currentPageNumber, totalPageNumber) => {
      for (let i = totalPageNumber; i > 0; i--) {
        if (s.includes(i)) {
          return i;
        }
      }
      return currentPageNumber;
    };
    const navigate = useNavigate();
    return (
      <div className={styles.main_div}>
        <div className={styles.top_hr}></div>
        <div className={styles.header_section_main}>
          {currentPageNumber === 1 && (
            <div name="編　集" className={styles.header_section}>
              編　　集
            </div>
          )}
          <AddressInfoDiv title={currentPageNumber + "冊目"} item={item} />
        </div>
        {currentPageNumber > 1 && (
          <div className={styles.multi_page_selector_wrapper}>
            <div className={styles.multi_page_selector}>
              <EditScreenSelector
                takeupspace={true}
                options={copyOptions}
                callback={(value) => {
                  console.log(value);
                  changeCopyDetails(
                    extractNumber(value, currentPageNumber, totalPageNumber),
                    index
                  );
                  // changeState("sec03textbox", value);
                  // setSec03textbox(value);
                }}
                selected={copySelected}
              />
            </div>
          </div>
        )}
        {selectedCopyDetails === currentPageNumber && (
          <>
            <div className={styles.choice_section}>
              <div className={styles.choice_section_title}>
                1.台紙パターンを選択してください
              </div>
              <div className={styles.radio_section_main}>
                <div className={styles.radio_section02}>
                  <div className={styles.element0}>
                    <div className={styles.radio_button}>
                      <input
                        className={styles.radio}
                        type="radio"
                        name={"language" + index}
                        checked={midDouble}
                        //   onChange={() => {}}
                        onClick={(event) => {
                          changeStateMultiple(
                            ["midDouble", "imageMiddle01", "imageMiddle02"],
                            [true, "", ""]
                          );
                        }}
                      />
                    </div>
                    <div className={styles.radio_text}>
                      パターン１（写真４枚）　
                    </div>
                  </div>
                  <div className={styles.element + " " + styles.radio_button_2}>
                    <div className={styles.radio_button}>
                      <input
                        className={styles.radio}
                        type="radio"
                        checked={!midDouble}
                        onClick={(event) => {
                          changeStateMultiple(
                            ["midDouble", "imageMiddle01", "imageMiddle02"],
                            [false, "", ""]
                          );
                        }}
                        name={"language" + index}
                      />
                    </div>
                    <div className={styles.radio_text}>
                      パターン２（写真３枚）
                    </div>
                  </div>
                </div>
              </div>
              <div className={styles.choice_section_info}>
                2.ギャラリーから写真を枚数分選択してください。
              </div>
              <div className={styles.choice_section_info_paragraph}>
                ※横写真は横向き、縦写真は縦向きで挿入されます。
              </div>
              <div className={styles.upload_section_main_div}>
                <div
                  onClick={(event) => {
                    uploadImage(4, 0);
                  }}
                  className={styles.upload_image_placeholder}
                >
                  <img
                    className={styles.upload_image_gallery_icon}
                    src={gallery_icon}
                    alt="top_gallery"
                  />

                  <div className={styles.upload_image_placeholder_text}>
                    写真選択
                  </div>
                </div>
              </div>
              <div className={styles.upload_section_header_main}>
                <div className={styles.upload_section_header_main_text}>
                  3.写真の配置を決定してください。ドラッグで写真位置の入れ替えが可能です。
                  <div
                    onClick={() => {
                      navigate("/point-photo-1");
                    }}
                    className={styles.upload_section_header_sub_text}
                  >
                    <img
                      src={play_icon}
                      className={styles.link_play_icon}
                      alt="l-play-ico"
                    />
                    写真配置のポイント
                  </div>
                </div>
              </div>
            </div>
            <div ref={divRef} className={styles.image_section_main}>
              <div className={`${styles.image_section_single_main}`}>
                <div className={styles.image_section_single_image}>
                  {imageLeft !== "" && (
                    <img
                      src={imageLeft}
                      onLoad={(event) =>
                        checkAspectRatio(event, setImageLeftStyle)
                      }
                      style={imageLeftStyle}
                      alt="l-img"
                    />
                  )}
                </div>
                {imageLeft !== "" && (
                  <div
                    onClick={() => {
                      console.log("calling callback");
                      changeState("imageLeft", "");
                      //   console.log("Cross the image");
                    }}
                    data-html2canvas-ignore="true"
                    className={styles.cross_div}
                  >
                    <ion-icon
                      className={styles.cross_icon}
                      name="close"
                    ></ion-icon>
                  </div>
                )}
                <div className={styles.upload_wrapper}>
                  {imageLeft === "" && (
                    <div
                      onClick={(event) => {
                        uploadImage(1, 1);
                      }}
                      className={styles.upload_image_placeholder}
                    >
                      <img
                        className={styles.upload_image_gallery_icon}
                        src={gallery_icon}
                        alt="top_gallery"
                      />
                      <div className={styles.upload_image_placeholder_text}>
                        写真選択
                      </div>
                    </div>
                  )}
                </div>
              </div>

              <div
                className={`${styles.image_section_single_main} ${styles.ss1}`}
              >
                <div className={styles.image_section_single_image}>
                  {!midDouble && imageMiddle01 !== "" && (
                    <img
                      src={imageMiddle01}
                      onLoad={(event) =>
                        checkAspectRatio(event, setImageMidStyle)
                      }
                      style={imageMidStyle}
                      alt="l-img"
                      crossOrigin="anonymous"
                    />
                  )}
                  <div className={styles.upload_wrapper}>
                    {!midDouble && imageMiddle01 === "" && (
                      <div
                        onClick={(event) => {
                          uploadImage(1, 2);
                        }}
                        className={styles.upload_image_placeholder}
                      >
                        <img
                          className={styles.upload_image_gallery_icon}
                          src={gallery_icon}
                          alt="top_gallery"
                        />

                        <div className={styles.upload_image_placeholder_text}>
                          写真選択
                        </div>
                      </div>
                    )}
                  </div>
                  {midDouble && imageMiddle01 !== "" && (
                    <img
                      src={imageMiddle01}
                      onLoad={(event) =>
                        checkSmallerAspectRatio(event, setImageMidStyle)
                      }
                      style={{
                        ...imageMidStyle,
                        position: "absolute",
                        top: 30,
                        right: 30,
                      }}
                      alt="m02-img"
                      crossOrigin="anonymous"
                    />
                  )}
                  {midDouble && imageMiddle01 === "" && (
                    <div className={styles.upload_image_small_left_wrapper}>
                      <div
                        onClick={(event) => {
                          uploadImage(1, 2);
                        }}
                        className={styles.upload_image_placeholder}
                      >
                        <img
                          className={styles.upload_image_gallery_icon}
                          src={gallery_icon}
                          alt="top_gallery"
                        />

                        <div className={styles.upload_image_placeholder_text}>
                          写真選択
                        </div>
                      </div>
                    </div>
                  )}
                  {midDouble && imageMiddle02 === "" && (
                    <div className={styles.upload_image_small_right_wrapper}>
                      <div
                        onClick={(event) => {
                          uploadImage(1, 3);
                        }}
                        className={styles.upload_image_placeholder}
                      >
                        <img
                          className={styles.upload_image_gallery_icon}
                          src={gallery_icon}
                          alt="top_gallery"
                        />

                        <div className={styles.upload_image_placeholder_text}>
                          写真選択
                        </div>
                      </div>
                    </div>
                  )}
                  {midDouble && imageMiddle02 !== "" && (
                    <img
                      src={imageMiddle02}
                      onLoad={(event) =>
                        checkSmallerAspectRatio(event, setImageMidStyle)
                      }
                      style={{
                        ...imageMidStyle,
                        position: "absolute",
                        bottom: 30,
                        left: 30,
                      }}
                      alt="m02-img"
                      crossOrigin="anonymous"
                    />
                  )}
                </div>
                {imageMiddle01 !== "" && (
                  <div
                    onClick={() => {
                      console.log("calling callback");
                      //   console.log("Cross the image");
                      changeState("imageMiddle01", "");
                    }}
                    data-html2canvas-ignore="true"
                    className={styles.cross_div}
                  >
                    <ion-icon
                      className={styles.cross_icon}
                      name="close"
                    ></ion-icon>
                  </div>
                )}
                {midDouble && imageMiddle02 !== "" && (
                  <div
                    onClick={() => {
                      console.log("calling callback");
                      //   console.log("Cross the image");
                      // setImageMiddle02("");

                      changeState("imageMiddle02", "");
                    }}
                    data-html2canvas-ignore="true"
                    className={styles.cross_div02}
                  >
                    <ion-icon
                      className={styles.cross_icon}
                      name="close"
                    ></ion-icon>
                  </div>
                )}
              </div>

              <div
                className={`${styles.image_section_single_main} ${styles.ss1}`}
              >
                <div className={styles.image_section_single_image}>
                  {imageRight !== "" && (
                    <img
                      src={imageRight}
                      onLoad={(event) =>
                        checkAspectRatio(event, setImageRightStyle)
                      }
                      style={imageRightStyle}
                      alt="r-img"
                      crossOrigin="anonymous"
                    />
                  )}
                </div>
                {imageRight !== "" && (
                  <div
                    onClick={() => {
                      console.log("calling callback");
                      // setImageRight("");
                      changeState("imageRight", "");
                      //   console.log("Cross the image");
                    }}
                    data-html2canvas-ignore="true"
                    className={styles.cross_div}
                  >
                    <ion-icon
                      className={styles.cross_icon}
                      name="close"
                    ></ion-icon>
                  </div>
                )}
                <div className={styles.upload_wrapper}>
                  {imageRight === "" && (
                    <div
                      onClick={(event) => {
                        uploadImage(1, 4);
                      }}
                      className={styles.upload_image_placeholder}
                    >
                      <img
                        className={styles.upload_image_gallery_icon}
                        src={gallery_icon}
                        alt="top_gallery"
                      />

                      <div className={styles.upload_image_placeholder_text}>
                        写真選択
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
            <div className={styles.bottom_info}>
              実際の商品は台紙枠に合わせて数cmトリミングされます。ご了承ください。
            </div>
          </>
        )}
        {totalPageNumber === 1 && (
          <div className={styles.preview_button_main}>
            <button
              onClick={() => {
                setPreview(true);
                copyImageToPreview();
              }}
              className={styles.preview_button}
            >
              プレビュー
            </button>
          </div>
        )}
        {totalPageNumber > 1 && (
          <div className={styles.edit_done_button_div}>
            <button
              className={styles.edit_done_multiple_button}
              onClick={() => {
                console.log("Save This Page");
                saveThisProduct();
                // downloadBlackBorderImage();
              }}
            >
              {currentPageNumber + "個目を保存"}
            </button>
          </div>
        )}
        {preview && (
          <div ref={previewRef} className={styles.preview_section_main_div}>
            <div className={styles.preview_hr}></div>
            <div className={styles.header_section}>
              <div className={styles.header_section_header}>
                イメージプレビュー
              </div>
            </div>
            <div className={styles.preview_image_main}>
              <img
                src={previewImage}
                height={366}
                width={1096}
                alt="preview_image"
              />
            </div>
          </div>
        )}
      </div>
    );
  }
);
export default MountSide3setsReusable;
